import { SecureRoute } from 'components/shared/secure_route';
import { ViewMounter } from 'components/view_mounter';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducerState } from 'redux/reducers';

import { Panel, PanelPresets, UserPermissionsIds } from 'utility/enumerations';

interface PatientContainerScreenProps {
  patientIdEncrypted: string
}

function PatientContainerScreen(props: PatientContainerScreenProps) {
  const { patientIdEncrypted } = props;
  return (
    <div>
      <SecureRoute
        path="/patient/profile/:id/cards/:isnew"
        pathPermissionId={UserPermissionsIds.ViewPatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/cards/patient_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/profile/:id/orders"
        pathPermissionId={UserPermissionsIds.ViewPatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/list/orders_list',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/profile/:id/cards/calculations/:tab"
        pathPermissionId={UserPermissionsIds.ViewPatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/profile/:id/calculations/:tab"
        pathPermissionId={UserPermissionsIds.ViewPatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/profile/:id/dispensation/:orderId"
        pathPermissionId={UserPermissionsIds.CreateDispensations}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'dispenser/dispensation/dispensation',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: undefined,
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/my-profile/cards/:isnew"
        pathPermissionId={UserPermissionsIds.PatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/cards/patient_profile_cards',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/my-profile/orders"
        pathPermissionId={UserPermissionsIds.PatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/list/orders_list',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/my-profile/cards/calculations/:tab"
        pathPermissionId={UserPermissionsIds.PatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/patient/my-profile/calculations/:tab"
        pathPermissionId={UserPermissionsIds.PatientProfile}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'patient/orders/calculations/patient_calculations',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
      <SecureRoute
        path="/:appType/update-demographics/:id"
        pathPermissionId={undefined}
        allowAnonymous
        render={(props) => ViewMounter(props, {
          viewPath: 'applications/form/update_demographics_form',
          targetPanel: Panel.Primary,
          panelLayout: PanelPresets.OneFull,
          clear: true,
          viewProps: undefined,
          focusView: false,
          overrideLocation: '',
          params: undefined
        })}
        component={undefined}
      />
      <SecureRoute
        path="/patient/my-profile/certdocs"
        pathPermissionId={UserPermissionsIds.AccessPatientCertificationDocumentationStatus}
        render={(props) => ViewMounter(props, [{
          viewPath: 'patient/mmtc_view/patient_profile',
          targetPanel: Panel.Primary,
          panelLayout: undefined,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          focusView: undefined,
          params: undefined
        },
        {
          viewPath: 'physician/patient_management/patient_cert_docs_screen',
          targetPanel: Panel.Secondary,
          panelLayout: PanelPresets.OneThirdTwoThird,
          focusView: true,
          clear: undefined,
          viewProps: { patientIdEncrypted },
          overrideLocation: undefined,
          params: undefined
        }])}
        allowAnonymous={undefined}
        component={undefined}
      />
    </div>
  );
}

const mapStateToProps = (state: RootReducerState) => {
  return {
    patientIdEncrypted: state.security?.user?.patientIdEncrypted
  };
};
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(PatientContainerScreen);
